import { FC, ReactNode } from 'react';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { InfoIcon } from '@phosphor-icons/react';

import { TooltipCard } from './TooltipCard';

export interface TipProps {
  title: ReactNode;
  placement?: 'bottom' | 'top' | 'left' | 'right';
  iconSize?: number;
}

/**
 * Small info "(i)" affordance with an on-hover explanation. A thin wrapper over
 * the shared {@link TooltipCard} (the `dark` variant) so every inline hint in
 * the app shares the same surface, theme and RTL handling.
 */
export const Tip: FC<TipProps> = observer(({ title, placement = 'top', iconSize = 16 }) => {
  return (
    <TooltipCard
      variant="dark"
      placement={placement}
      description={title}
      maxWidth={600}
      sx={{ minWidth: 200 }}
    >
      <IconButton
        size="small"
        sx={{
          width: 20,
          height: 20,
          padding: 0,
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'text.primary',
          },
        }}
      >
        <InfoIcon size={iconSize} />
      </IconButton>
    </TooltipCard>
  );
});
